import { Box, Button, Chip, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useResearchTasks } from "../../common/contexts/ResearchTaskProvider";
import PersonDetails from "../Components/PersonDetails";

const ResearchPersonDetailsPage = () => {
  const { personId } = useParams<{ personId: string }>();
  const { getTaskById } = useResearchTasks();
  const task = personId ? getTaskById(personId) : undefined;
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => navigate(-1)}
        sx={{
          mb: 2,
          px: 2.5,
          py: 1,
          borderRadius: 2,
          fontWeight: 500,
          boxShadow: "none",
          textTransform: "none",
          alignSelf: "flex-start",
          transition: "background 0.2s",
          "&:hover": {
            backgroundColor: "#f5f5f5",
            boxShadow: "0 1px 4px 0 rgba(0,0,0,0.10)",
            borderColor: "primary.main",
          },
        }}
        startIcon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: "block" }}
            aria-hidden="true"
          >
            <path
              d="M12.5 15L8 10.5L12.5 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        Back
      </Button>
      {task?.task_result && <PersonDetails person={task.task_result.person} />}

      {task?.task_result?.tags && task?.task_result?.tags.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom>
            Tags
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {task?.task_result?.tags.map((tag, index) => (
              <Chip
                key={tag.tag_id || index}
                label={tag.tag_name}
                color="primary"
                variant="outlined"
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ResearchPersonDetailsPage;
